var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{staticClass:"header",attrs:{"title":_vm.title,"fixed":_vm.fixed,"left-arrow":""},on:{"click-left":_vm.onLeftClick}})}
var staticRenderFns = []

export { render, staticRenderFns }